var map = {
	"./BBW_3550.jpg": 6640,
	"./BBW_3551.jpg": 5853,
	"./BBW_3554.jpg": 6900,
	"./BBW_3555.jpg": 4945,
	"./IMG_1801.JPG": 9536,
	"./IMG_1802.JPG": 4271,
	"./IMG_1806.JPG": 8547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4980;